import { inject, provideAppInitializer } from '@angular/core';

import { select, Store } from '@ngrx/store';
import {
  ClientAuthSelectors,
  ProductSearchPage,
  ProductSelectors,
  RoutingService,
  StateWithProduct
} from '@spartacus/core';
import { filter, take } from 'rxjs/operators';

import { DpGtmService } from '@app/core/services/gtm.service';
import { DpProductsService } from '@app/core/services/products.service';

class DpInitializer {
  constructor(
    protected routingService: RoutingService,
    private readonly store: Store<StateWithProduct>,
    private readonly dpProductsService: DpProductsService,
    private readonly dpGtmService: DpGtmService
  ) {
    this.dpProductsService.initializeListener().subscribe();
    this.dpGtmService.initializeListener().pipe(take(1)).subscribe();
    this.dpGtmService.loginListener().subscribe();
    this.dpGtmService.logoutListener();

    this.store
      .pipe(
        select(ProductSelectors.getSearchResults, ClientAuthSelectors.getClientAuthState),
        filter(({ relatedParts, freeTextSearch }: ProductSearchPage, authState: number) => {
          const userAuthorized = authState > 0;
          const productCount = relatedParts?.[0]?.categories?.[0]?.products?.length;

          return (!productCount || productCount === 0) && userAuthorized && !!freeTextSearch;
        })
      )
      .subscribe(() => void this.routingService.go('searchEmpty'));
  }
}

const dpAppInitializerFactory =
  (
    routingService: RoutingService,
    store: Store<StateWithProduct>,
    dpProductsService: DpProductsService,
    dpGtmService: DpGtmService
  ): (() => DpInitializer) =>
  (): DpInitializer =>
    new DpInitializer(routingService, store, dpProductsService, dpGtmService);

export const DP_OVERRIDES_MODULE_INITIALIZER_PROVIDER = provideAppInitializer(() => {
  const initializerFn = dpAppInitializerFactory(
    inject(RoutingService),
    inject(Store),
    inject(DpProductsService),
    inject(DpGtmService)
  );
  initializerFn();
});
